import { useQueryClient } from "@tanstack/react-query";

import { rqClient } from "@/shared/api/instance";

export function useCreateWithdrawal() {
  const queryClient = useQueryClient();

  return rqClient.useMutation("post", "/api/v1/withdrawals", {
    onSettled: async () => {
      await queryClient.invalidateQueries(
        rqClient.queryOptions("get", "/api/v1/withdrawals", {}),
      );
      await queryClient.invalidateQueries(
        rqClient.queryOptions("get", "/api/v1/withdrawals/stats", {}),
      );
      await queryClient.invalidateQueries(
        rqClient.queryOptions("get", "/api/v1/stores/balance", {}),
      );
      await queryClient.invalidateQueries(
        rqClient.queryOptions("get", "/api/v1/stores/transactions", {}),
      );
    },
  });
}
